import Mana from "@/components/Spellify/Mana/Mana";

import styles from './ManaString.module.scss'
import classNames from "classnames";

interface Props {
    line: string
    pid?: string
    size?: number
    lengthIndex?: number
    className?: string
}

function Test({line, pid, size, lengthIndex}: Props) {
    // if (line.includes('{') && !line.includes('_')) {
        // console.log(line)
    if (line.includes('{')) {
        return (<Mana color={line.replace(/[^A-Z0-9]/g, '')} className={classNames(styles.manaspan, pid==="cardcost" && styles.manacost)} pid={pid} lengthIndex={lengthIndex}/>)
    }
    else {
        return `${line}`
    }
}

const ManaString = ({line, pid, size, lengthIndex, className}: Props) => {
    // console.log(pid)
    // console.log(line)
    return (
        <p id={pid} className={className}>
            {/* {line.split(/({\s?[A-Z2]?\s?\/?\s?[A-Z]?[0-20]?\s?}|{\s?_\s?})/g).map((part: string, index: number) => (
                <Test line={part} key={index}></Test>
            ))} */}
            {line.split(/({[A-Z2]?\/?[A-Z]?[0-9]?}|{_}|{[_|\d\w]\/[_|\d\w]})/g).map((part: string, index: number) => (
                <Test line={part} key={index} pid={pid} lengthIndex={lengthIndex}/>
            ))}
        </p>
    )
}

export default ManaString